import apiM from '../GlobalEnv'

  
  let i = 1;


const validateRes = resData => {
    if(resData.status === 200){
        return resData
    } else {
        throw new Error('failed to process')
    }
}
const resJson = resData => resData.json()

export const modifyFs = async (arr) => {
 
    let data = arr
    // console.log(data)
    // /finance/:userID/modify/:loginStr
    const api =apiM + `/finance/${sessionStorage.getItem('mail')}/modify/${sessionStorage.getItem('lStr')}`
    let init = {
        method:'post', 
        body:JSON.stringify(data), 
        'headers':{'content-type':'application/json'},
        mode:'cors'
    }
    try {
        let res = await fetch(api,init)
        .then(validateRes).then(resJson).catch(e => e.message) 
        //   console.log(res)
           return res     
    
    }
    catch(e) {
        // console.log(e)
    }
} 

export const postFS = async (dataF) => {
     let data = dataF
    const api = apiM + `/finance/${sessionStorage.getItem('mail')}/${sessionStorage.getItem('lStr')}`

    let init = {
            method:'post', 
            body:JSON.stringify(data), 
            'headers':{'content-type':'application/json'},
            mode:'cors'
        }
try {
    // let res = await fetch(api,init).then(validateRes).then(resJson).catch(e => console.log( e.message )) 
    let res = await fetch(api,init)
    let mRes = await res
     

    //   let ans = mRes.json()
    //   if(ans.error === 'duplicate') {
    //       //dispatvh a action
    //   }
// if(mRes.json()) console.log(  mRes.json() )
// console.log('is not working',await mRes)
       return mRes.json()
    
//    else throw Error
} 
catch (e) {
    // console.log(e)
    alert('An error occured, pls refresh the page')
 }
    
    
     }

export const indicator = (loading = true) => ({
    'type': 'INFORM_UI',
    'load': {isLoading: loading}

})
export const getFs = () => {
    const api = apiM +  `/finance/${sessionStorage.getItem('mail')}/${sessionStorage.getItem('lStr')}`
    return async dispatch => {
        dispatch(indicator())
        try {
            let res = await fetch(api)
            // console.log(res)
            let resData = res.json()
            
            let dData = await resData
            // console.log(dData)
          const {error} = dData

          if(error) throw new Error(error)
        
     dispatch(updateStoreFromApi(await resData))
     dispatch({type: "DATA_SUCCESS", load: {isLoading: false}})
        
      
    }
    
    catch(e) {
          console.log(e.message)
          if(e.message === 'you are not logged in') {
              return dispatch(indicator('not logged in'))
          }
          if(e.message === 'You seem not to have a Financial Struc with us pls do so at the finance page') {
            return dispatch(indicator('no load'))
          }
          if(e.message === 'We couldnt fine some of your details pls refresh the page and retry') {
            return dispatch(indicator(false))
          }
        // switch (e.message) {
        //     case 'load is not iterable': return dispatch(indicator('no load'))
        
        //     default:return dispatch(indicator(false))
                 
        // }
    }
   } 

 
      
}


export const specRecivBud = ({purpose, budg, amt}) => ({
    'type': 'SPEC_RECIV_BUDG',
    'load': {purpose, budg, amt}
})

export const addFinStruc = ({budg, rPerc}) => {
    return  ({

'type': 'ADD_FS',
'load': {budg,  rPerc, color: 'green', money: 0, _id: i++, updated: true}

})
}  

export const remFinStruc = _id => ({
    'type': 'REM_FS',
    'load': _id
})

 export const changeColoFinStruc = color => ({
     'type': 'Ch_Co',
     'load':  color
 })

 export const getBudget = () => ({
    'type': 'GET_BUDG'
})
 
export const spendBudget = ({budg, amt, purpose}) => ({
    'type': 'SPENT_BUDG',
    'load': {budg, amt, purpose}
})
export const recivBudget = ({purpose, amt}) => ({
    
    'type': 'RECIV_BUDG',
    'load': {purpose, amt,}
})

export const updateStoreFromApi = (data = {}) => ({
    'type': 'UPDATE_S_API',
    'load': data
})